const STORAGE_KEY_PREFIX = "b3-session-duration";
const DEFAULT_DAYS = 7;
// 0 = session cookie (expires when browser closes)
export const SESSION_DURATION_OPTIONS = [0, 1, 7, 14, 30];
function storageKey(partnerId) {
    return partnerId ? `${STORAGE_KEY_PREFIX}_${partnerId}` : STORAGE_KEY_PREFIX;
}
/**
 * Read session duration for a specific partner.
 *
 * preferences shape: { [partnerId]: { sessionDuration: number }, sessionDuration?: number }
 *
 * Priority: user.preferences[partnerId].sessionDuration
 *           → user.preferences.sessionDuration (global fallback)
 *           → localStorage (per-partner) → localStorage (global) → default 7d
 */
export function getSessionDurationDays(userPreferences, partnerId) {
    if (userPreferences) {
        if (partnerId) {
            const v = userPreferences[partnerId]?.sessionDuration;
            if (SESSION_DURATION_OPTIONS.includes(v))
                return v;
        }
        const v = userPreferences["sessionDuration"];
        if (SESSION_DURATION_OPTIONS.includes(v))
            return v;
    }
    try {
        if (partnerId) {
            const stored = localStorage.getItem(storageKey(partnerId));
            if (stored !== null) {
                const parsed = Number(stored);
                if (SESSION_DURATION_OPTIONS.includes(parsed))
                    return parsed;
            }
        }
        const stored = localStorage.getItem(STORAGE_KEY_PREFIX);
        if (stored !== null) {
            const parsed = Number(stored);
            if (SESSION_DURATION_OPTIONS.includes(parsed))
                return parsed;
        }
    }
    catch {
        // localStorage unavailable (e.g. SSR)
    }
    return DEFAULT_DAYS;
}
export const SESSION_DURATION_LABELS = {
    0: "Session only",
    1: "1 day",
    7: "7 days",
    14: "14 days",
    30: "30 days",
};
/** Cache the preference locally so it's available immediately on next login */
export function setSessionDurationDays(days, partnerId) {
    try {
        localStorage.setItem(storageKey(partnerId), String(days));
    }
    catch {
        // ignore
    }
}
